
import { Routes, Route } from 'react-router-dom'
import { Layout } from 'frame'
import { List } from './components'
import { DrillDown } from 'features/fleet/components'

export const ModuleRoutes = () => (
  <Layout>
    <List />
    <Routes>
      <Route path=":id/*" element={<DrillDown />} />
    </Routes>
  </Layout>
)

export default ModuleRoutes
